import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import DeleteDark from 'src/assets/images/DeleteDark.svg';
import { sizes } from 'src/styles/Media.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY_DEMI, SEMANTIC_TEXT_SMALL_PX, SEMANTIC_TEXT_XSMALL_PX, TITLE_FONT_COLOR } from '../../../../../styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';


const useStyles = makeStyles(() => ({
    root: {
        alignItems: 'center',
        flexGrow: 1,
        height: '100%',
        margin: '0px',
        width: '100%',
    },
    paper: {
        padding: '0px',
        border: '1px solid #DCDCDC',
        borderRadius: '6px 6px 0px 0px',
        boxShadow: '0px 3px 2px #00000029',
        height: 48,
        opacity: 1,
        background: 'white',
        font: 'normal normal normal 13px/22px Avenir Next World',
        letterSpacing: 0,
        color: '#3C3C3C',
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

const ReportPaymentHeader = ({
    headerReportPaymentCheckboxClickHandler,
    allSelected,
    winWidth,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    // const winWidth = window.innerWidth;

    // const isDesktopView = winWidth >= sizes.mediumDevice;
    // const isTabletView =
    //     winWidth >= sizes.smalDevice && winWidth < sizes.mediumDevice;

    return (
        <React.Fragment>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <Grid container spacing={2} className={classes.root}>
                    <GridHeaderContainer
                        mbPadding={'8px 8px 8px 16px!important'}
                        padding={'8px 8px 8px 20px!important'}
                        height={'100%'}
                        display={'flex'}
                        alignItems={'center'}
                        item
                        xs={6}
                        sm={12}
                        md={3}
                        lg={3}
                        xl={3}
                    >
                        <div style={{ display: 'flex' }}>
                            <Checkbox
                                id="reportUsage-reportpayment-headerCheckbox"
                                checked={
                                    allSelected
                                    // reportPaymentGridData &&
                                    // reportPaymentGridData.length > 0 &&
                                    // reportPaymentGridData
                                    //     .filter((x) => !x.isExclusionItem)
                                    //     .every((y) => y.isSelected)
                                }
                                label={t(
                                    'reportUsage.record.reportPaymentTable.selectAll'
                                )}
                                labelStyleObj={{
                                    fontFamily: FONT_FAMILY_DEMI,
                                    textAlign: 'left',
                                    fontSize: SEMANTIC_TEXT_SMALL_PX,
                                    letterSpacing: '-0.12px',
                                    color: TITLE_FONT_COLOR,
                                    opacity: 1,
                                    paddingLeft: SEMANTIC_TEXT_XSMALL_PX,
                                }}
                                onCheckboxSelectionChange={
                                    headerReportPaymentCheckboxClickHandler
                                }
                            />
                            {/* <Box
                                sx={{
                                    marginLeft: '11px',
                                    color: '#1010EB',
                                    fontFamily: 'AvenirNextWorld Demi',
                                }}
                            >
                                Select All
                            </Box> */}
                        </div>
                    </GridHeaderContainer>
                    <GridHeaderContainer
                        item
                        md={9}
                        lg={9}
                        xl={9}
                        columns={13}
                        padding={'8px 0px 8px 0px!important'}
                        height={'100%'}
                        display={'flex'}
                        alignItems={'center'}
                        mbDisplay={'none'}
                        smDisplay={'none'}
                    >
                        <GridHeader
                            item
                            xs={2}
                            md={3}
                            lg={3}
                            xl={3}
                            display={'flex'}
                            justifyContent={'center'}
                        >
                            <GridBox>{t('reportUsage.record.reportPaymentTable.gridBox')}</GridBox>
                        </GridHeader>
                        <GridHeader
                            item
                            md={2}
                            lg={2}
                            xl={2}
                            display={'flex'}
                            justifyContent={'center'}
                        >
                            <GridBox width={'60px'}>{t('reportUsage.record.reportPaymentTable.qty')}</GridBox>
                        </GridHeader>
                        <GridHeader
                            item
                            xs={2}
                            md={2}
                            lg={2}
                            xl={2}
                            display={'flex'}
                            justifyContent={'center'}
                        >
                            <GridBox>{t('reportUsage.record.reportPaymentTable.unitPrice')}</GridBox>
                        </GridHeader>
                        <GridHeader
                            item
                            xs={2}
                            md={2}
                            lg={2}
                            xl={2}
                            display={'flex'}
                            justifyContent={'center'}
                        >
                            <GridBox>{t('reportUsage.record.reportPaymentTable.extPrice')}</GridBox>
                        </GridHeader>
                        <GridHeader
                            item
                            xs={1}
                            md={3}
                            lg={3}
                            xl={3}
                            display={
                                winWidth <= sizes.mobileDevice ? 'none' : 'flex'
                            }
                            justifyContent={'center'}
                        >
                            <GridBox>{t('reportUsage.record.reportPaymentTable.poInformation')}</GridBox>
                        </GridHeader>
                        <GridHeader
                            item
                            xs={1}
                            md={1}
                            lg={1}
                            xl={1}
                            display={'flex'}
                            justifyContent={'center'}
                        >
                            <Box>
                                <GridDeleteImg
                                 id="reportUsage-reportpayment-delete-all-header-button"
                                    src={DeleteDark}
                                    onClick={() => {
                                        try {
                                            /*console.log("delete all in record payment");*/
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></GridDeleteImg>
                            </Box>
                        </GridHeader>
                    </GridHeaderContainer>
                </Grid>
            </Box>
        </React.Fragment>
    );
};
export default ReportPaymentHeader;

export const GridHeaderContainer = styled(Grid)`
    padding: ${({ padding }) => padding};
    height: ${({ height }) => height};
    display: ${({ display }) => display};
    align-items: ${({ alignItems }) => alignItems};
    ${media.smalDevice`
          padding: ${({ mbPadding }) => mbPadding};
          display: ${({ smDisplay }) => smDisplay};
    `}
    ${media.mobileDevice`
         padding: ${({ mbPadding }) => mbPadding};
         display: ${({ mbDisplay }) => mbDisplay};
    `}
`;

export const GridHeader = styled(Grid)`
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
`;
export const GridDeleteImg = styled.img`
    width: 20px;
    height: 20px;
    cursor: default;
`;
export const GridBox = styled(Box)`
    font-family: 'AvenirNextWorld Demi';
    width: ${({ width }) => width};
`;
